<template>
    <div class="root">
        <div class="d-flex" style="width: 100%; padding: 12px">
            <hr width="40%" color="midnightblue" size="1">
            <span class="allTxt">Our projects</span>
            <hr width="40%" color="midnightblue" size="1">
        </div>
        <div class="container">
            <carousel/>
        </div>
        <p class="projectInfo">
            L’histoire se déroule sur une côte du Japon. Dans un vieux temple abandonné sur la montagne vit un jeune moine. Un jour une Kitsune à la recherche de son compagnon Goupil déboule dans sa vie. Ils se lancent ensemble à sa recherche. Cependant, ils vont vite se rendre compte que des esprits en ont après eux. Dans leur quête de vérité, ils découvriront que les esprits sont en colère contre la race humaine et qu’une grande catastrophe pourrait bien menacer l’équilibre entre le monde physique et le monde spirituel. Ils devront alors affronter des esprits en colère et une secte qui leur est dévouée. Ils voyageront à travers divers décors, telles que des forêts enchantées et peuplées d’êtres étranges, ainsi que le monde des rêves et celui des esprits. Dans la recherche de l’ami disparu, ils découvrent le complot visant à détruire l’équilibre, un étrange démon semble impliqué d’une manière ou d’une autre dans cette histoire...
        </p>
    </div>
</template>

<script>
import carousel from '@/components/carousel';

export default {
    name: 'projects',
    components: {
        carousel,
    }
}
</script>

<style lang="stylus" scoped>

.root {
    display: flex;
    align-items: center;
    flex-direction: column;
    .container {
        width: 100%;
        max-width: 800px;
    }
    .projectInfo {
        max-width: 80%;
        margin: 18px;
        background: silver;
    }
}

</style>